import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthService} from './auth.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isAuthenticated()) {
      if (this.checkLastLoginDate()) {
        return true;
      } else {
        return this.authService.logout();
      }
    } else {
      // Redirect to the login page if not authenticated
      return this.authService.logout();
    }
  }

  checkLastLoginDate(): boolean {
    const lastLoginDate = this.authService.getLastLoginDate();

    if (lastLoginDate) {
      const now = new Date();
      const diffInHours = (now.getTime() - lastLoginDate.getTime()) / (1000 * 60 * 60);
      return diffInHours <= 24;
    }
    return false;
  }
}
